import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';
import Toggle from 'react-toggle';
import getLocale from '../../../i18n/getLocale';

class ContractsEditTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: false,
      id: this.props.contract_id,
      aircrafts_list: [],
      clients_list: [],
      contract_backups: [],
      name: this.props.contract_data.name,
      management: this.props.contract_data.management,
      type: this.props.contract_data.type,
      backup_aircraft_id: null,
      contract_backup_number: null,
      availability: this.props.contract_data.availability,
      date_start: this.props.contract_data.date_start,
      consumption: this.props.contract_data.consumption,
      payment_type: this.props.contract_data.payment_type,
      due_date: this.props.contract_data.due_date,
      availability_time: this.props.contract_data.availability_time,
      interruption_time: this.props.contract_data.interruption_time,
      interruption_start: this.props.contract_data.interruption_start,
      spare_time: this.props.contract_data.spare_time,
      charter: this.props.contract_data.charter,
      xml: this.props.contract_data.xml,
      noturno: 0,
      carga_externa: 0,
      comissarios: 0,
      age_filter: this.props.contract_data.age_filter,
      age_filter_maximum: this.props.contract_data.age_filter_maximum,
      aircraft_id: this.props.contract_data.aircraft_id,
      base_id: this.props.contract_data.base_id,
      client_id: this.props.contract_data.client_id,
      expire_str: this.props.contract_data.expire_str,
      errors_messages: [],
      errors_listing: false,
    };

    //bind específico
    this.edit = this.edit.bind(this);
    this.addBackup = this.addBackup.bind(this);
    this.deleteBackup = this.deleteBackup.bind(this);

    // Handlers
    this.locale = getLocale();

  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  // LM
  componentWillReceiveProps(newProps) {
    if(typeof this.state.name === 'undefined' && typeof newProps.contract_data.name !== 'undefined') {
      this.setState({
        id: newProps.contract_id,
        name: newProps.contract_data.name,
        management: newProps.contract_data.management,
        type: newProps.contract_data.type,
        noturno: newProps.contract_data.noturno,
        carga_externa: newProps.contract_data.carga_externa,
        client_id: newProps.contract_data.client_id,
        aircraft_id: newProps.contract_data.aircraft_id,
        base_id: newProps.contract_data.base_id,
        comissarios: newProps.contract_data.comissarios,
        expire: newProps.contract_data.expire_str,
        age_filter: newProps.contract_data.age_filter,
        age_filter_maximum: newProps.contract_data.age_filter_maximum,
        backup_aircraft_id: newProps.contract_data.backup_aircraft_id,
        availability: newProps.contract_data.availability,
        date_start: newProps.contract_data.date_start_str,
        consumption: newProps.contract_data.consumption,
        payment_type: newProps.contract_data.payment_type,
        due_date: newProps.contract_data.due_date,
        availability_time: newProps.contract_data.availability_time,
        interruption_time: newProps.contract_data.interruption_time,
        interruption_start: newProps.contract_data.interruption_start,
        spare_time: newProps.contract_data.spare_time,
        charter: newProps.contract_data.charter,
        xml: newProps.contract_data.xml,
      });
    }
    if(Array.isArray(newProps.aircrafts_list) && Array.isArray(newProps.clients_list) && Array.isArray(newProps.contract_backups) && Array.isArray(newProps.bases_list) && this.state.loaded === false) {
      this.setState({aircrafts_list: newProps.aircrafts_list});
      this.setState({bases_list: newProps.bases_list});
      this.setState({clients_list: newProps.clients_list});
      this.setState({contract_backups: newProps.contract_backups});
      this.setState({loaded: true});
    }
  }

  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      aircraft_id: this.state.aircraft_id,
      base_id: this.state.base_id,
      client_id: this.state.client_id,
      name: this.state.name,
      management: this.state.management,
      type: this.state.type,
      expire: this.state.expire,
      age_filter: this.state.age_filter,
      age_filter_maximum: this.state.age_filter_maximum,
      noturno: this.state.noturno,
      carga_externa: this.state.carga_externa,
      comissarios: this.state.comissarios,
      availability: this.state.availability,
      date_start: this.state.date_start,
      consumption: this.state.consumption,
      payment_type: this.state.payment_type,
      due_date: this.state.due_date,
      availability_time: this.state.availability_time,
      interruption_time: this.state.interruption_time,
      interruption_start: this.state.interruption_start,
      spare_time: this.state.spare_time,
      charter: this.state.charter,
      xml: this.state.xml,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/contrato', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({
            errors_listing: false,
            errors_messages: [],
          });
        } else if(responseJson.status === 'warning') {
          self.setState({
            errors_listing: true,
            errors_messages: responseJson.data,
          });
        } else {
          self.setState({
            errors_listing: false,
            errors_messages: [],
          });
        }
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  // Adição de backup
  addBackup(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      contract_id: this.state.id,
      aircraft_id: this.state.backup_aircraft_id,
      number: this.state.contract_backup_number,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/contrato/backup', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        if(responseJson.status === 'success') {
          self.setState({contract_backups: responseJson.data});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  // Deletar backup
  deleteBackup(id) {
    if (window.confirm(this.locale.Contratos.EditarContrato.deletarBackup)) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/contrato/backup/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          if(responseJson.status === 'success') {
            self.setState({contract_backups: responseJson.data});
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  {this.state.errors_listing &&
    <div className="alert alert-danger alert-dismissible" role="alert" style={{marginTop: 25}}>
      <button onClick={() => self.setState({ errors_listing: false, errors_messages: [], })} type="button" className="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
      <strong>{this.locale.Contratos.EditarContrato.erros}:</strong>
      {Object.keys(self.state.errors_messages).map(function(k) {
        var message = self.state.errors_messages[k];
        return (
          <p>- {message}</p>
        );
      })}
    </div>
  }
  <form onSubmit={this.edit}>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Contratos.EditarContrato.formularioCliente.Cliente}:</label>
          <Select
            className="form-field-name"
            name="client_id"
            value={this.state.client_id}
            searchable={true}
            placeholder={this.locale.Contratos.EditarContrato.formularioCliente.placeholder.SelecionarCliente}
            onChange={this.handleSelectChange.bind(this, 'client_id')}
            options={this.state.clients_list}
            disabled
          />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Contratos.EditarContrato.formularioCliente.Aeronave}:</label>
          <Select
            className="form-field-name"
            name="aircraft_id"
            value={this.state.aircraft_id}
            searchable={true}
            placeholder={this.locale.Contratos.EditarContrato.formularioCliente.placeholder.SelecionarAeronave}
            onChange={this.handleSelectChange.bind(this, 'aircraft_id')}
            options={this.state.aircrafts_list}
            disabled
          />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Contratos.EditarContrato.formularioCliente.Tipo}:</label>
          <Select
            className="form-field-name"
            name="type"
            value={this.state.type}
            searchable={true}
            placeholder={this.locale.Contratos.EditarContrato.formularioCliente.placeholder.EstadoDoEmpregador}
            onChange={this.handleSelectChange.bind(this, 'type')}
            options={[
              {value: "normal", label: this.locale.Contratos.EditarContrato.formularioCliente.opcoesTipo.TripulacaoRegular},
              {value: "noturno", label: this.locale.Contratos.EditarContrato.formularioCliente.opcoesTipo.TripulacaoNoturna},
              {value: "medvac", label: this.locale.Contratos.EditarContrato.formularioCliente.opcoesTipo.TripulacaoMEDVAC},
              {value: "normal_comissarios", label: this.locale.Contratos.EditarContrato.formularioCliente.opcoesTipo.TripulacaoRegularComComissarios},
              {value: "noturno_comissarios", label: this.locale.Contratos.EditarContrato.formularioCliente.opcoesTipo.TripulacaoNoturnaComComissarios},
              {value: "medvac_comissarios", label: this.locale.Contratos.EditarContrato.formularioCliente.opcoesTipo.TripulacaoMEDVACComComissarios},
            ]}
            required
          />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Contratos.EditarContrato.formularioCliente.NumDeContrato}:</label>
          <input type="text" name="name" className="form-control" placeholder={this.locale.Contratos.EditarContrato.formularioCliente.placeholder.NumeroDeContrato} value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Contratos.EditarContrato.formularioCliente.Gerencia}:</label>
          <input type="text" name="management" className="form-control" placeholder={this.locale.Contratos.EditarContrato.formularioCliente.placeholder.Gerencia} value={this.state.management} onChange={this.handleChange.bind(this, 'management')} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Contratos.EditarContrato.formularioCliente.IdadeMinimaEmAnos}:</label>
          <input type="number" name="age_filter" className="form-control" placeholder={this.locale.Contratos.EditarContrato.formularioCliente.placeholder.IdadeMinimaEmAnos} value={this.state.age_filter} onChange={this.handleChange.bind(this, 'age_filter')} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Contratos.EditarContrato.formularioCliente.IdadeMaximaEmAnos}:</label>
          <input type="text" name="age_filter_maximum" className="form-control" placeholder={this.locale.Contratos.EditarContrato.formularioCliente.placeholder.IdadeMaximaEmAnos} value={this.state.age_filter_maximum} onChange={this.handleChange.bind(this, 'age_filter_maximum')} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Contratos.EditarContrato.formularioCliente.Inicio}:</label>
          <InputMask value={this.state.date_start}  maskChar={null} name="date_start " mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder={this.locale.Contratos.EditarContrato.formularioCliente.placeholder.DataDeInicio} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Contratos.EditarContrato.formularioCliente.Termino}:</label>
          <InputMask value={this.state.expire}  maskChar={null} name="expire " mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'expire')} placeholder={this.locale.Contratos.EditarContrato.formularioCliente.placeholder.DataDeTermino} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Contratos.EditarContrato.formularioCliente.DiaFixoDeVencimento}:</label>
          <InputMask value={this.state.due_date}  maskChar={null} name="due_date " mask="99" className="form-control" onChange={this.handleChange.bind(this, 'due_date')} placeholder={this.locale.Contratos.EditarContrato.formularioCliente.placeholder.DiaFixoDeVencimento} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Contratos.EditarContrato.formularioCliente.TipoDePagamento}:</label>
          <Select
            className="form-field-name"
            name="payment_type"
            value={this.state.payment_type}
            searchable={true}
            placeholder={this.locale.Contratos.EditarContrato.formularioCliente.placeholder.TipoDePagamento}
            onChange={this.handleSelectChange.bind(this, 'payment_type')}
            options={[
              {value: 'Partida ao Corte', label: this.locale.Contratos.EditarContrato.formularioCliente.opcoesTipoDePagamento.PartidaAoCorte},
              {value: 'Decolagem ao Pouso', label: this.locale.Contratos.EditarContrato.formularioCliente.opcoesTipoDePagamento.DecolagemAoPouso}
            ]}
            required
          />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Contratos.EditarContrato.formularioCliente.Consumo}:</label>
          <input value={this.state.consumption} name="consumption" className="form-control" onChange={this.handleChange.bind(this, 'consumption')} placeholder={this.locale.Contratos.EditarContrato.formularioCliente.placeholder.Consumo} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Contratos.EditarContrato.formularioCliente.TempoDeDisponibilidade}:</label>
          <InputMask value={this.state.availability} name="availability " mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'availability')} placeholder={this.locale.Contratos.EditarContrato.formularioCliente.placeholder.Disponibilidade} required />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Contratos.EditarContrato.formularioCliente.HoraInicialDaDisponibilidade}:</label>
          <InputMask value={this.state.availability_time}  maskChar={null} name="availability_time " mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'availability_time')} placeholder={this.locale.Contratos.EditarContrato.formularioCliente.placeholder.HoraInicialDaDisponibilidade} required />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>{this.locale.Contratos.EditarContrato.formularioCliente.BaseContratual}:</label>
        <Select
          className="form-field-name"
          name="base_id"
          value={this.state.base_id}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'base_id')}
          options={this.state.bases_list}
          required
        />
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Contratos.EditarContrato.formularioCliente.XML}:</label>
          <br/>
          <Toggle
            checked={this.state.xml}
            aria-label='No label tag'
            name="xml"
            onChange={this.handleToggleChange.bind(this, 'xml')} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Contratos.EditarContrato.formularioCliente.Noturno}:</label>
          <br/>
          <Toggle
            checked={this.state.noturno}
            aria-label='No label tag'
            name="noturno"
            onChange={this.handleToggleChange.bind(this, 'noturno')} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Contratos.EditarContrato.formularioCliente.CargaExterna}:</label>
          <br/>
          <Toggle
            checked={this.state.carga_externa}
            aria-label='No label tag'
            name="carga_externa"
            onChange={this.handleToggleChange.bind(this, 'carga_externa')} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Contratos.EditarContrato.formularioCliente.Comissarios}:</label>
          <br/>
          <Toggle
            checked={this.state.comissarios}
            aria-label='No label tag'
            name="comissarios"
            onChange={this.handleToggleChange.bind(this, 'comissarios')} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Contratos.EditarContrato.formularioCliente.Fretamento}:</label>
          <br/>
          <Toggle
            checked={this.state.charter}
            aria-label='No label tag'
            name="charter"
            onChange={this.handleToggleChange.bind(this, 'charter')} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-12">
        <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Contratos.EditarContrato.formularioCliente.botaoSalvarEdicao}</button>
      </div>
    </div>
  </form>
  <hr/>
  <h4>{this.locale.Contratos.EditarContrato.adicionarBackup}</h4>
  <hr/>
  <form onSubmit={this.addBackup}>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Contratos.EditarContrato.formularioAdicionarBackup.AeronaveBackup}:</label>
          <Select
            className="form-field-name"
            name="backup_aircraft_id"
            value={this.state.backup_aircraft_id}
            searchable={true}
            placeholder={this.locale.Contratos.EditarContrato.formularioAdicionarBackup.placeholder.SelecionarAeronaveDeBackup}
            onChange={this.handleSelectChange.bind(this, 'backup_aircraft_id')}
            options={this.state.aircrafts_list}
            required
          />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Contratos.EditarContrato.formularioAdicionarBackup.Numero}:</label>
          <input type="number" name="contract_backup_number" className="form-control" placeholder="" value={this.state.contract_backup_number} onChange={this.handleChange.bind(this, 'contract_backup_number')} required />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-12">
        <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Contratos.EditarContrato.formularioAdicionarBackup.botaoSalvarBackup}</button>
      </div>
    </div>
  </form>
  <hr/>
  <h4>{this.locale.Contratos.EditarContrato.backups}</h4>
  <hr/>
  <table className="table">
    <thead>
      <tr>
        <th>{this.locale.Contratos.EditarContrato.tabelaBackup.Numero}</th>
        <th>{this.locale.Contratos.EditarContrato.tabelaBackup.Aeronave}</th>
        <th>{this.locale.Contratos.EditarContrato.tabelaBackup.Acoes}</th>
      </tr>
    </thead>
    <tbody id="frotas">
      {Object.keys(self.state.contract_backups).map(function(k) {
        return (
          <tr>
            <td>{self.state.contract_backups[k].aircraft.registration}</td>
            <td>{self.state.contract_backups[k].number}</td>
            <td>
              <button className="btn btn-sm btn-danger" onClick={() => self.deleteBackup(self.state.contract_backups[k].id)}>
                <i className="fa fa-fw fa-trash"></i>
              </button>
            </td>
          </tr>
        );
      })}
    </tbody>
  </table>
</div>
    );
  }
}

export default ContractsEditTab;



// WEBPACK FOOTER //
// ./src/Components/Contracts/Elements/ContractsEditTab.js